<template>
  <div>
    <v-layout class="pull-left">
      <v-dialog
        :modelValue="show"
        max-width="450px"
        @keydown.esc="closeModal"
        @click:outside="closeModal"
      >
        <v-card>
          <v-form v-on:submit.prevent="performeAction">
            <v-card-title style="margin-bottom: 0px !important">
              <span class="headline">Bloquear/Desbloquear Ubicaciones</span>
            </v-card-title>

            <v-card-text>
              <p class="fs-16 mt-4">Se ejecutara la accion sobre {{ selected.length }} ubicaciones.</p>
              <v-radio-group v-model="action">
                <v-radio
                  style="margin-top: 10px"
                  label="Bloquear"
                  value="bloquear"
                ></v-radio>
                <v-radio
                  style="margin-top: 10px"
                  label="Desbloquear"
                  value="desbloquear"
                ></v-radio>
              </v-radio-group>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="closeModal">Cancelar</v-btn>
              <v-btn
                color="success"
                text
                type="submit"
                :loading="loading_action"
                :disabled="loading_action || selected.length == 0 || action == ''"
                >Ejecutar</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { ubicacionService } from "@/libs/ws/ubicacionService";
import { ca } from "vuetify/lib/locale/index.mjs";
export default {
  props: {
    show: Boolean,
    close: Function,
    selected: Array,
    list: Array,
    cleanSelected: Function,
    reloadList: Function,
  },
  name: "Bloquear",
  mixins: [],
  created() {},
  data() {
    return {
      loading_action: false,
      action: "",
    };
  },
  mounted() {},
  computed: {},
  methods: {
    closeModal(){
      this.action = "";
      this.loading_action = false;
      this.$emit("close");
    },
    performeAction() {      
      let ids = this.selected.map((id) => {
        let item = this.list.find((item) => item.id == id);
        return item.id;
      });

      const params = {
        ubicaciones_ids: ids,
        action: this.action,
      }
      
      this.loading_action = true;

      ubicacionService.performeAction(params)
        .then((response) => {
          if(response.status === true){            
            this.$emit("reloadList");
            this.closeModal();
            this.$emit("cleanSelected");
          }else{
            this.toast.error(response.msg);
          }          
        })
        .catch((error) => {
          this.toast.error(error);
        })
        .finally(() => {
          this.loading_action = false;
        });    
    },    
  },
};
</script>
